import type { AiDraftsTranslation } from './types';

export const aiDraftsAr: AiDraftsTranslation = {
  title: 'مسودة من الذكاء الاصطناعي للمراجعة',
  by: 'كتبها {{name}} (ذكاء اصطناعي) من مصادر عامة. لا يُرسل شيء حتى توافق عليها.',
  textLabel: 'مسودة الرد',
  badge: 'مسودة جاهزة',
  approve: 'الموافقة والإرسال',
  edit: 'تعديل',
  editLabel: 'عدّل المسودة قبل إرسالها',
  sendEdited: 'إرسال بعد التعديل',
  cancelEdit: 'إلغاء التعديل',
  emptyEdit: 'اكتب الرد قبل إرساله، أو ألغِ التعديل.',
  reject: 'رفض',
  sent: 'أُرسلت المسودة باسمك.',
  editedSent: 'أُرسلت مسودتك بعد التعديل.',
  notSent: 'لم يُرسل. ردّك محفوظ مع رسائلك التي لم تُرسل بعد: حاول إرساله مرة أخرى من مربع الرد.',
  rejected: 'رُفضت المسودة. لم يُرسل شيء.',
  closedBy: 'قرّر {{name}} بشأن هذه المسودة بالفعل.',
  closed: 'لم تعد هذه المسودة مناسبة للمحادثة.',
  rejectDialog: {
    title: 'رفض هذه المسودة',
    description: 'لا يُرسل شيء إلى العميل. يُحفظ سببك مع المسودة لتحسين المساعد.',
    reason: 'لماذا ترفضها؟',
    reasonMissing: 'اختر سببًا.',
    note: 'ملاحظة',
    submit: 'رفض المسودة',
    reasons: {
      inaccurate: 'إنها خاطئة',
      incomplete: 'ينقصها شيء',
      wrong_tone: 'الأسلوب غير مناسب',
      not_needed: 'لا حاجة إلى رد',
      other: 'سبب آخر',
    },
  },
  ended: {
    approved: 'أرسل {{name}} هذه المسودة.',
    edited: 'أرسل {{name}} نسخة معدّلة من هذه المسودة.',
    rejected: 'رفض {{name}} هذه المسودة: {{reason}}.',
    customer_wrote: 'استُبدلت المسودة: كتب العميل مجددًا.',
    owner_changed: 'تُركت المسودة جانبًا: انتقلت المحادثة إلى شخص آخر.',
    answered: 'تُركت المسودة جانبًا: ردّ أحدهم يدويًا.',
    replaced: 'حلّت مسودة أحدث محل هذه.',
    resolved: 'تُركت المسودة جانبًا: أُغلقت المحادثة.',
    dismiss: 'إخفاء',
  },
};
